import { memo, useEffect } from 'react'
import { Button } from '@ow/comps'
import { dayjsInit } from '@ow/utils'
import { useAppEx, useTbViewStore, TbViewProvider } from '@vt/hooks'
import Exporter from '../../tables/triggers/exporter'

const ExportBtn = ({ curDate, selectedUser, useList, filter }) => {
  const setFilters = useTbViewStore((state) => state.setFilters)

  useEffect(() => {
    const [startDate, endDate] = curDate
    const filters = {
      logicType: 'and',
      queries: [
        {
          slug: 'createdAt',
          queryType: 'dayRange',
          value: {
            startDate: dayjsInit(startDate).startOf('day').toDate(),
            endDate: dayjsInit(endDate).endOf('day').toDate(),
          },
        },
      ],
    }

    if (selectedUser) {
      filters.queries.push({
        slug: 'createdBy',
        queryType: 'equal',
        value: selectedUser.id,
      })
    } else {
      filters.queries.push({
        slug: 'createdBy',
        queryType: 'inList',
        value: useList.map((u) => u.id),
      })
    }

    if (filter.checkItem) {
      filters.queries.push({
        slug: 'checkItem',
        queryType: 'equal',
        value: filter.checkItem,
      })
    }

    if (filter.district) {
      filters.queries.push({
        slug: 'district',
        queryType: 'like',
        value: filter.district,
      })
    }
    setFilters(filters, true, false)
  }, [curDate, selectedUser, filter])

  return (
    <Exporter>
      <Button className="mb-2" stroke>
        导出
      </Button>
    </Exporter>
  )
}

const ViewWrapper = ({ tbId, vid, ...rest }) => {
  const appId = useAppEx((state) => state.appId)

  if (!vid) return null

  return (
    <TbViewProvider appId={appId} tbId={tbId} vid={vid}>
      <ExportBtn {...rest} />
    </TbViewProvider>
  )
}

export default memo(ViewWrapper)
